import { toast } from "react-toastify";

export const confirmEmailInfo = () => {
  toast.error("Potwierdź swój adres email");
};
